import { Selector, createSelector } from "reselect";
import { ResponseMessages } from "@sms/shared/message/message.interface";
import { ActivePhonesData } from "@sms/shared/active-phones/active-phones.interface";
import { UserData } from "@sms/shared/users/users.interface";

import { ApplicationStore } from "../application.store";

export const selectCurrentMessages: () => Selector<ApplicationStore, ResponseMessages[]> = (): Selector<
  ApplicationStore,
  ResponseMessages[]
> =>
  createSelector(
    [
      (state: ApplicationStore): ResponseMessages[] | null => state.message.messages,
      (state: ApplicationStore): string | null => state.chats.selectChatId
    ],
    (messages, chatId) => {
      if (!messages || !chatId) {
        return [];
      }

      return messages.filter(message => message.chatId === chatId);
    }
  );

export const selectCurrentUserId: Selector<ApplicationStore, string | undefined> = createSelector(
  (state: ApplicationStore): UserData | null => state.auth.user,
  user => user?.id
);

export const makeSelectUsedActivePhoneByMessageId: () => Selector<
  ApplicationStore,
  ActivePhonesData | undefined
> = (): Selector<ApplicationStore, ActivePhonesData | undefined> =>
  createSelector(
    (state: ApplicationStore): ActivePhonesData[] => state.activePhones.activePhones ?? [],
    (state: ApplicationStore, messageId: string): ResponseMessages | undefined =>
      (state.message.messages ?? []).find(message => messageId === message.id),
    (activePhones, message) => activePhones.find(phone => phone.activePhoneId === message?.activePhone?.activePhoneId)
  );
